//import jaLocale from 'element-ui/lib/locale/lang/ja'
import store from "../../../store";

module.exports = {
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'クリア'
        },
        datepicker: {
            now: '現在',
            today: '今日',
            cancel: 'キャンセル',
            clear: 'クリア',
            confirm: 'OK',
            selectDate: '日付を選択',
            selectTime: '時間を選択',
            startDate: '開始日',
            startTime: '開始時間',
            endDate: '終了日',
            endTime: '終了時間',
            prevYear: '前年',
            nextYear: '翌年',
            prevMonth: '前月',
            nextMonth: '翌月',
            year: '年',
            month1: '1月',
            month2: '2月',
            month3: '3月',
            month4: '4月',
            month5: '5月',
            month6: '6月',
            month7: '7月',
            month8: '8月',
            month9: '9月',
            month10: '10月',
            month11: '11月',
            month12: '12月',
            // week: '週次',
            weeks: {
                sun: '日',
                mon: '月',
                tue: '火',
                wed: '水',
                thu: '木',
                fri: '金',
                sat: '土'
            },
            months: {
                jan: '1月',
                feb: '2月',
                mar: '3月',
                apr: '4月',
                may: '5月',
                jun: '6月',
                jul: '7月',
                aug: '8月',
                sep: '9月',
                oct: '10月',
                nov: '11月',
                dec: '12月'
            }
        },
        select: {
            loading: 'ロード中',
            noMatch: 'データなし',
            noData: 'データなし',
            placeholder: '選択してください'
        },
        cascader: {
            noMatch: 'データなし',
            loading: 'ロード中',
            placeholder: '選択してください',
            noData: 'データなし'
        },
        pagination: {
            goto: '',
            pagesize: '件/ページ',
            total: '総計 {total} 件',
            pageClassifier: 'ページ目へ'
        },
        messagebox: {
            title: 'メッセージ',
            confirm: 'OK',
            cancel: 'キャンセル',
            error: '正しくない入力'
        },
        upload: {
            deleteTip: 'Delキーを押して削除する',
            delete: '削除する',
            preview: 'プレビュー',
            continue: '続行する'
        },
        table: {
            emptyText: 'データなし',
            confirmFilter: '確認',
            resetFilter: '初期化',
            clearFilter: 'すべて',
            sumText: '合計'
        },
        tree: {
            emptyText: 'データなし'
        },
        transfer: {
            noMatch: 'データなし',
            noData: 'データなし',
            titles: ['リスト 1', 'リスト 2'],
            filterPlaceholder: 'キーワードを入力',
            noCheckedFormat: '総計 {total} 件',
            hasCheckedFormat: '{checked}/{total} を選択した'
        },
        image: {
            error: 'FAILED' // to be translated
        },
        pageHeader: {
            title: 'Back' // to be translated
        }
    },
    netError: "ネットワーク接続エラーが発生しました。しばらくしてから再試行してください",
    cancel:"終了",
    confirm:"確認",
    delete:"削除",
    save:"保存",
    rename:"名称変更",
    userSpace: "個人ストレージ",
    entSpace: "企業ストレージ",
    allUser: "すべてのユーザー",
    frozen: "凍結済み",
    upload: "アップロード",
    import: "インポート",
    tips: "ヒント",
    prompt: "ヒント",
    success: "成功",
    return: "戻る",
    edit:"編集",
    close: "閉じる",
    noSearch: "検索結果がありません",
    loadmore: "さらに読み込む",
    retry: "再試行",
    allDelete: "すべて削除する",
    nextStep:"次へ",
    nodata:'関連の検索結果がありませんでした',
    back: "前へ",
    edas: {
        loginIcon: 'ログインアイコン',
        filterCondition: "フィルタ条件の設定",
        enterFilter: 'フィルタ条件を設定した後、Base DN下のノードを設定したフィルタ条件でフィルタリングします。現在はLDAP filterの文法フォーマットがサポートされています。例えば、cn=D_group1',
        ad: 'AD',
        baseDN: 'Base DN',
        appId: 'appId',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        authentication: '企業認證',
        URL:'URL',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        serviceList: 'サービスリスト',
        all: 'Select all',
        agentId: 'agentId',
        status: 'ステータス',
        operation: '操作',
        cancel: '終了',
        confirm: '確認',
        next: '次へ',
        last: '前へ',
        delete: '削除',
        tips: 'ヒント',
        weaver:'泛微',
        weaverOA:'泛微OA',
        customize: 'カスタム',
        none: 'なし',
        submit: '提出',
        departmentID: '部门标识字段',
        departmentName: '部门名称字段',
        parentDepartment:'父部门',
        agentTips:'当前服务类型无需选择代理名称',
        syncMode: '同步方式',
        syncOrganization: '同步到组织',
        syncTeam: '同步到团队',
        syncUserOnly: '仅同步用户',
        syncOrganizationToolTip: '将对接系统的组织和人员同步到网盘组织中',
        syncTeamToolTip: '将对接系统的人员同步到组织下，将对接系统的组织结构同步到团队中',
        syncUserOnlyToolTip: '仅将对接系统的人员同步到组织根节点下，不同步组织',
        hours: '時',
        mins: '分',
        more: 'より',
        back: '戻る ',
        detail: '详细',
        object: '対象',
        action: '操作',
        remarks: '備考',
        success: '成功',
        team: 'グループ',
        move: '移动',
        frozen: '凍結',
        netError: "ネットワーク接続エラーが発生しました。しばらくしてから再試行してください",
        setFilter: '设置过滤条件',
        import: 'インポート',
        modify: '変更',
        upload: 'アップロード',
        edit: '編集',
        condition: '个条件',
        loadMore: 'さらに読み込む',
        items: '項',
        organization:'組織',
        unSyncOrganization:'未同步组织',
        urlTip:'请输入带http://或https://的URL',
        title: "企業アカウントの認証",
        subHeader: "オープンプラットフォームを企業ドメインとドッキングして、企業の既存のユーザーと組織構造を迅速に導入して同期させることができます。",
        importServerConfig: "組織インポートサービスの設定",
        sync: "組織インポートサービスの設定",
        authServerConfig: "ログイン認証サービスの設定",
        auth: "ログイン認証サービスの設定",
        agentName: "プロキシ名",
        serviceName: "サービス名",
        serial: "シリアル番号",
        ctime: "作成時間",
        addAgentServer: "プロキシサービスを追加する",
        addServerConfig: "サービス設定を追加する",
        editServerConfig: "サービス設定を編集する",
        autoSyncTime: "自動同期時間",
        lastSyncTime: "前回の同期時間",
        newAgentSrver: "プロキシサービスを新規作成する",
        unbound: "紐づけを解除する",
        unbind: "紐づけていません",
        normal: "正常",
        disconnect: "接続切れ",
        hasAddAgentServer: "プロキシサービスを追加しました",
        unboundTips: "紐づけを解除すると、このプロキシサービスが利用できなくなります。引き続き解除しますか？",
        confirmUnbound: "引き続き解除する",
        deleteTips: "削除すると、このサービスの紐づけが解除され、関連パラメーターも消去されます。よろしいですか？",
        serviceType: "サービスタイプ",
        corpWX: "企業WeChat",
        dingding: "DingTalk",
        connectConfig: "接続設定",
        serviceAddress: "サーバーアドレス",
        serviceManageAccount: "サーバーの管理アカウント",
        password: "パスワード",
        port: "ポート",
        fieldMapping: "フィールドマッピング",
        userID: "ユーザーマークフィールド",
        userNameField: "ユーザー名フィールド",
        emailField: "ユーザーメールアドレスフィールド",
        mobileField: "ユーザー携帯番号フィールド",
        login: "ユーザーログインフィールド",
        teamID: "グループマークフィールド",
        teamName: "グループ名フィールド",
        allowMailImportToBeEmpty: "メールアドレスのインポートは、空であっても構いません。",
        mailImportToolTip: "チェックを外した場合、空にしないでください。メールアドレスが空であるユーザーをインポートしません。",
        customField: "カスタマイズフィールド",
        lenovoboxField: "クラウドストレージフィールド",
        importField: "フィールドをインポートする",
        addField: "フィールドを追加する",
        syncConfig: "設定を同期する",
        defaultImportMode: "デフォルトのインポート方法",
        allImport: "すべてインポートする",
        allNoImport: "どれもインポートしない",
        syncTime: "執行時間を同期する",
        accordingDay: "日で",
        accordingHour: "時間で",
        hour: "時間",
        min: "分",
        adfsCertificate: "adfs証明書 (jks形式)",
        certificatePassword: "証明書のパスワード",
        adfsAddress: "ADFSアドレス",
        everyday: "毎日",
        every: "ごと",
        syncOperation: "今すぐ同期する",
        log: "ログ",
        setServiceConfig: "サービス設定を設定する",
        setFiltrationConditions: "フィルタリング条件を設定する",
        deleteSuccess: "削除しました",
        syncCompleteTime: "完成時間を同期する",
        syncSuccess: "同期しました",
        syncFail: "同期できませんでした",
        unSync: "同期されていません",
        unSyncToolTip: "ブラックリストにフィルタリングされ、同期されていないデータ",
        export: "エクスポート",
        syncDetail: "同期の詳細情報",
        detailSyncTime: "同期時間",
        allSyncResult: "すべての同期結果",
        failReasons: "失敗の原因",
        fail: "失敗",
        user: "ユーザー",
        created: "作成",
        update: "更新",
        unfrozen: "解凍",
        filter: "フィルタリング済み",
        unSyncUser: "同期されていないユーザー",
        unSyncTeam: "同期されていないグループ",
        importServiceConfigCuccess: "インポートサービスの設定を追加しました！",
        filterInquiry: "インポートのフィルタリング条件を今すぐ設定しますか？",
        noSettings: "今は設定しない",
        goSettings: "設定する",
        addFilter: "条件を追加する",
        addFilterCondition: "フィルタリング条件を追加する",
        modifyFilterCondition: "フィルタリング条件を変更する",
        batchImport: "一括インポート",
        userEmail: "ユーザーメールアドレス",
        userPhone: "ユーザー携帯番号",
        userName: "ユーザー名",
        teamUser: "グループ名",
        filteringContent: "フィルタリング対象",
        allConditionalType: "すべての条件タイプ",
        allFilterMode: "すべてのフィルタリング方法",
        noImport: "インポートしない",
        conditionalType: "条件タイプ",
        filterMode: "フィルタリング方法",
        importModeDesc: "インポート方法は、サービス設定で変更できます",
        addedNumber: "追加済み",
        addedText: "の条件",
        first: "ステップ1",
        downloadTemp: "テンプレートをダウンロードします",
        downloadTempDesc: "xlsまたはxlsxファイルとなります",
        second: "ステップ2",
        editedUpload: "内容を編集してからアップロードします",
        uploadCertificate: "証明書をアップロードする",
        deleteItem: "選択した項目を削除する",
        selectedText: "選択した項目を削除しますか？",
        importLogTitle: "設定したログリストをインポートする",
        mostNumber: "最大は10のフィールドに関連する",
        enterLenovoboxField: "クラウドストレージフィールドを入力してください",
        enterImportField: "インポートするフィールドを入力してください",
        agentRelease: "プロキシの紐づけが解除されました",
        noServiceConfig: "サービス設定を追加していません",
        noAgentService: "プロキシサービスを追加していません",
        syncConfigDesc: "提出すると、フィルタリング条件を追加し、一部のユーザーをフィルタリングできます。",
        noDetailResulr: "関連する検索結果がありません",
        filterTitleTip: "デフォルトでは、すべてのデータをインポートするようになっています。どれもインポートしないように設定したり、条件を追加して一部のデータをインポートしたりできます。",
        importAcount: "合計はをインポートしました",
        copy: "コピー",
        copySuccess: "コピーしました",
        copyFail: "コピーできませんでした",
        serviceNamePlaceholder: "サービス設定名を入力してください。最大は50特殊文字を入力できます。",
        serviceAddressPlaceholder: "例えば：120.22.100.11",
        manageAccountPlaceholder: "接続するサーバー管理アカウントを入力してください",
        enterPasswordPlaceholder: "パスワードを空にしないでください",
        enterSearchValue: "検索内容を入力してください",
        selectFilterType: "フィルタリング条件のタイプを入力してください",
        enterEmail: "ユーザーメールアドレスを入力してください",
        enterUserPhone: "ユーザー携帯番号を入力してください",
        enterUserName: "ユーザー名を入力してください",
        enterTeamName: "グループ名を入力してください",
        noSearchResult: "グループ名を入力してください別のキーワードで再試行してください",
        beyondLimit: "10000件の上限を超えています",
        configSuccess: "設定しました",
        deleteConfirm: "削除しますか？",
        item: "個",
        noFilterSearchResult: "関連する検索結果がありません。別のキーワードで再試行してください",
        character: "サービス設定名を入力してください。最大は50特殊文字を入力できます。",
        noErrorSpecialCharacters: "以下の特殊文字は入力できません",
        isSyncing: "同期しています",
        jksFile: "jks形式",
        uploadJksFile: "jks形式のファイルをアップロードしてください",
        inputCertificatePassword: "証明書のパスワードを空にしないでください",
        address: "アドレスを入力してください",
        modifySuuccess: "変更しました",
        agentPlaceholder: "プロキシサービス名を入力してください。最大は50特殊文字を入力できます",
        inputTeamOrUser: "ユーザー名/グループ名を入力して検索する",
        addFilterSuccess: "フィルタリング条件を追加しました",
        modifyFilterSuccess: "フィルタリング条件を変更しました",
        errorEmail: "メールアドレスの形式が間違っています",
        errorMobile: "携帯番号の形式が間違っています",
        bindingServerConfig: "第三者紐づけサービスの設定",
        matchingRule: "マッチングルール",
        mobile: "携帯番号",
        email: "メールアドレス",
        syncResult: "同期結果",
        newBinding: "新規紐づけ",
        failBinding: "紐づけできませんでした",
        account: "アカウント",
        bindingLogTitle: "設定したログリストを紐づけする",
        inputAccount: "アカウントを入力してください",
        signCongit: "スキャンコード登録サービスの設定",
        SSO: "ワンポイント登録（SSO）サービス配置",
        sso: "ワンポイント登録（SSO）サービス配置",
        searchSuccess: 'クエリが成功しました',
        allSuccess:'Success',
        startSuccess:'Success',
        closeSuccess:'Success',
        uploadSuccess:'Success',
        scanName: 'ログイン名',
        boxUrl: 'ディスクアクセスアドレス',
        copyUrl: 'アドレスをコピー',
        identification: '識別情報を一致させる',
        appKeySecret: 'appKeySecret',
        ssoWarning: 'プロキシサービスを利用していますので、システムはプロキシサーバのアドレスを取得できませんので、ネットワークディスクを使ってアドレスにアクセスする時は、手動でプロキシサービスのIPまたはアドレスをxxxの場所に記入してください。https://lenovows.com/user/manager',
        agentWarning: 'プロキシサービスは最大1つの構成を追加します。',
        importWarning: '組織導入サービスは最大1つの設定を追加します。',
        authWarning: '登録認証サービスは最大1つの設定を追加します。',
        schema: 'schema',
        userStatus: 'ユーザの状態',
        probation:'仮採用',
        formal:'正式',
        temporary:'臨時',
        probationExtension:'試用延期',
        dismissal:'結納を解く',
        resignation:'職を離れる',
        retirement:'定年退職',
        invalid:'無効です。正式ユーザーのみ同期します。',
        importSealTeam:'保存チームを導入する',
        yes:'はい、',
        no:'いいえ、',
        relationship: '関係',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'応用証明書',
        applicationVoucherTitle:'ピンを接続するアプリケーション証明書を構成して、ピンユーザの基礎情報を取得する',
        scanLogin:'スキャンコード登録',
        qrcode:'スキャンコード登録',
        scanLoginTitle:'は、釘付けコード登録アプリケーションのライセンス情報を設定して、釘付けコードでネットディスクにログインすることを実現します',
        mobileAuthorizedLogin:'モバイル端末ライセンス登録',
        mobileAuthorizedLoginTitle:'はピンをセットする「モバイルアプリケーションアクセス-共有」のライセンス情報を、モバイル端末がピンで登録できるようにすることができます',
        kingdee: 'Kingdee',
        createSuperiorTeam: '親チームを自動的に作成する',
        createSuperiorOrg: '親組織を自動的に作成する',
        autCreateSuperiorTeam: '追加されたフィルター条件がチームに同期されると、優れたチームが自動的に作成されます',
        autCreateSuperiorOrg: '追加されたフィルター条件が組織に同期されると、親組織が自動的に作成されます',
        ...store.getters['ja']
    },
    app: {
        'thirdApp': '第三者アプリケーション',
        'appManager': 'アプリケーション管理',
        'createApp': 'アプリケーションを作成',
        'editApp': '適用を変更',
        'appName': '名前を適用',
        'appDesc': 'アプリケーションの説明',
        'appIcon': 'アイコンを使う',
        'ipManage': 'IP管理',
        'addIp': 'IPアクセスを追加',
        'appNameTip': 'アプリケーション名を50文字以内に入力してください',
        'addIpDesc': 'このアプリケーションにアクセスするIPを記入してください。複数のIPは「、」で区切ってください。IPセグメントを記入することをサポートします。IP開始アドレスと終了アドレスは「-」で区切られています。',
        'rateLimit': 'インターフェース周波数制限',
        'setRateLimit': 'インターフェース周波数の設定',
        'rateLimitDesc': 'アプリケーションが頻繁に起動されてサーバー負荷が異常になることを防止するために、デフォルトの場合、各サービス端末インターフェースの呼び出しには周波数制限があります。この制限を超えた場合、対応インターフェースを呼び出すと、対応するエラーコードが返されます。',
        'rateLimitNumber': '上限を示す数字が必要です',
        'rateLimitUnit': '回/分',
        'appVoucher': '応用証明書',
        'baseInfo': '基本情報',
        'appAvatar': 'アイコンを使う',
        'editInfo': '情報を編集',
        'backUp': 'アプリケーション管理に戻る',
        'deleteApp': 'アプリケーションを削除',
        'voucher': '証憑と基礎情報',
        'authManage': '権限管理',
        'createSuccess': '作成成功',
        'createError': '作成に失敗しました',
        'modifySuccess': '修正成功',
        'modifyError': '変更に失敗しました',
        'delSuccess': '削除に成功しました',
        'delError': '削除に失敗しました',
        'modifyAuthSuccess': 'バッチ設定成功',
        'modifyAuthError': '一括設定に失敗しました',
        'deleteConfirm2': '削除の確認',
        'appNumLimit': 'アプリケーションの数が上限に達しました，作成を続けられませんでした',
        'ipFormatError': 'IP範囲フォーマットエラー',
        'deleteConfirmTitle': '本当にこのアプリケーションを削除しますか？',
        'deleteDesc': 'アプリケーション情報を確認してください。削除後は回復できません。証明書は無効になります',
        'imgFormatLimit': 'アップロードはJPG/PNG形式のみ対応しています',
        'imgBulkLimit': '画像は120 KB以下でなければなりません',
        'imgSizeLimit': '画像は240*240 px以上でなければなりません',
        'imgTip': 'JPG/PNG形式、240*240 px以上、1:1、120 kb以内の角なしアイコンをアップロードしてください',
        'appNameRequired': '名前の適用は空ではありません',
        'appNameIsExit': 'アプリケーション名が使用されています',
        'ipRequired': 'アクセスIPを追加してください'
    },
};





// WEBPACK FOOTER //
// ./static/js/language/ja.js